"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=({size:t,center:e})=>({width:t,height:t,...e&&{display:"flex",width:"100%",justifyContent:"center"}});exports.loaderStyles=l;
